<form #thisForm="ngForm">
  <websilk-text-field id="txtUsername" class="font-sm" name="txtUsername" [(ngModel)]="request.UserName" displayInline="false" placeholderText="Username" required="true" errorText="Username is required" pattern=""></websilk-text-field>
  <websilk-text-field id="txtPassword" class="font-sm" name="txtPassword" [(ngModel)]="request.Password" displayInline="false" placeholderText="Password" required="true" errorText="Password is required" pattern="" fieldType="password"></websilk-text-field>

  <div class="d-flex flex-column">
    <button type="button" class="btn btn-primary btn-red pl-2 pr-2 btn-login w-100" *ngIf="!processing" (click)="PerformLogin(thisForm,$event)">Login</button>
    <span class="btn btn-dark" *ngIf="processing"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
    <a [routerLink]="['/reset-password']" class="btn btn-link float-right">
      Forgot Your Password?
    </a>
  </div>

  <div class="alert alert-danger p-2 rounded-0 mt-2" *ngIf="error!=''">
    <i class="fas fa-exclamation-circle text-red font-md p-0 pr-2"></i>
    <span class="text-opacity-7">{{error}}</span>
  </div>
</form>
